import React from "react";

import { Card, Divider, Form } from "antd";

import useLearningObjectivesFormPresenter from "@Totum/QuestionnaireBuilder/Presentation//hooks/useLearningObjectivesFormPresenter";
import RichTextEditor from "@Totum/Main/Components/shared/RichTextEditor";

import "draft-js/dist/Draft.css";

const LearningObjectivesForm = () => {
    const { handlers, uiModel } = useLearningObjectivesFormPresenter();

    return (
        <div className="questionnaire-designer designer">
            <Divider />
            <Card className="newUI-raised">
                <Form
                    name="questionnaire-edit"
                    className="questionnaire-edit-form designer-edit-form"
                    layout="vertical"
                >
                    <Form.Item label="Learning Objectives" name="description">
                        <RichTextEditor
                            key={uiModel.questionnaireId}
                            initialContent={uiModel.initialContent}
                            onChange={handlers.handleEditorChange}
                        />
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LearningObjectivesForm;
